import React from 'react'

const CommonHero = ({ pageTitle, custombackground }) => (
	<div className="page-header generalhead">
		<div
			className="page-banner"
			style={{
				background: `url(${
					custombackground
						? custombackground
						: 'https://res.cloudinary.com/brian-boals/image/upload/v1555484368/brianboals/slide11.jpg'
				})`,
			}}
		/>
		<div className="container">
			<div className="row">
				<div className="col-lg-12 mx-auto">
					<div className="text-center sildertxt">
						<p>Armstrong Real Estate Company /</p>
						<h1 className="text-white">{pageTitle}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default CommonHero
